module.exports = __webpack_public_path__ + "img/ic_invoices_white.06dbc895.svg";